import { render, staticRenderFns } from "./ShowAppliedBlocksButtons.vue?vue&type=template&id=21c19d16&"
import script from "./ShowAppliedBlocksButtons.vue?vue&type=script&lang=js&"
export * from "./ShowAppliedBlocksButtons.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports